import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from "../../components/Common/Header/Header";
import Footer from '../../components/Common/Footer/Footer';
import IntroSectionAppCloud from '../../components/AppCloud/IntroSectionAppCloud/IntroSectionAppCloud';
import ServicesCardsPrivateCloud from '../../components/PrivateCloud/ServicesCardsPrivateCloud/ServicesCardsPrivateCloud';
import ExpertiseSectionPrivateCloud from '../../components/PrivateCloud/ExpertiseSectionPrivateCloud/ExpertiseSectionPrivateCloud'
import PricingPrivateCloud from '../../components/PrivateCloud/PricingPrivateCloud/PricingPrivateCloud';
import ContactSection from '../../components/HomePage/ContactSectionHome/ContactSectionHome';
import ScrollingLogos from '../../components/Common/ScrollingLogos/ScrollingLogos';
import Navbar from "../../components/Common/Navbar/Navbar";
import Newsletter from '../../components/Common/Newsletter/Newsletter';
import ServiceList from '../../components/AppCloud/ServicesSliderAppCloud/ServicesSliderAppCloud';
import ParallaxComponent from '../../components/Common/ParallaxBackground/ParallaxComponent';
import appCloudParallaxText from '../../components/Common/ParallaxBackground/appCloudParallaxText';
import ParallaxIMG0 from './../../assets/images/itmonkeys-cyber-img-p0.png';
import ParallaxIMG1 from './../../assets/images/itmonkeys-cyber-img-p1.png';
import ParallaxIMG2 from './../../assets/images/itmonkeys-cyber-img-p2.png';
import ExpertiseSection from '../../components/AppCloud/ExpertiseSectionPrivateCloud/ExpertiseSectionPrivateCloud';
import IntroSectionBottom from '../../components/Common/IntroSectionBottom/IntroSectionBottom';
import introSectionData0 from '../../components/Common/IntroSectionBottom/introSectionData0';
import useSectionRefs from '../../hooks/useSectionRefs';
import BenefitsPrivateCloud from '../../components/AppCloud/ServicesSliderAppCloud/BenefitsPrivateCloud';
import { contactLinkData } from '../../data/contactLinkData';
import ContactLinkSection from '../../components/Common/ContactLinkSection/ContactLinkSection';
import TimelinePrivateCloud from '../../components/AppCloud/Timeline/TimelinePrivateCloud';
import { GridPatternCard, GridPatternCardBody } from '../../components/ui/card-with-ellipsis-pattern';

const AppCloud: React.FC = () => {
    const { t } = useTranslation();
    const sectionRefs = useSectionRefs();
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  
    const handleOpenContactModal = () => {
      setIsContactModalOpen(true);
    };
  
    const handleCloseContactModal = () => {
      setIsContactModalOpen(false);
    };

  return (
    <div>
      <section id="header" className="section dark" ref={sectionRefs.header}>
        <div>
          <Navbar 
            sectionRefs={sectionRefs}
            openContactModal={handleOpenContactModal}
            closeContactModal={handleCloseContactModal}
          />
          <Header 
            title={t('appCloud.header.title', "Déploiement cloud applicatif")} 
            subtitle={t('appCloud.header.subtitle', "Propulsez vos applications avec le cloud")} 
          />
        </div>
      </section>
      <section id="start" className="section light" ref={sectionRefs.start}>
        <IntroSectionAppCloud />
        <IntroSectionBottom data={introSectionData0} translationNamespace="appCloud" />
      </section>
      <div className="gradient-bg">

      <section id="start2" className="section dark" ref={sectionRefs.start2}>
      <ParallaxComponent
        images={{
          layer1: ParallaxIMG0,
          layer2: ParallaxIMG1,
          layer3: ParallaxIMG2,
        }}
        textContent={appCloudParallaxText}
        contentBelowParallax={<ExpertiseSection />}
        wrapperClassName="parallax__wrapper_cloudapp"
        translationNamespace="appCloud"
        />
          <div className="gradient-bg">
            <section
              id="expertise"
              className="section dark"
              ref={sectionRefs.expertise}
            >

          <BenefitsPrivateCloud />
          <TimelinePrivateCloud />
          <GridPatternCard>
      <GridPatternCardBody>
        <div className="tw-h-[5em]">
        </div>
      </GridPatternCardBody>
    </GridPatternCard>
          </section>
        </div>
        </section>
      <section id="cloud" className="section light" ref={sectionRefs.cloud}>
      </section>
      <section id="newsletter" className="section dark" ref={sectionRefs.newsletter}>
      <ContactLinkSection pageKey="appCloud" />
        <Footer />

      </section>
    </div>
    </div>
  );
};

export default AppCloud;
